<h1>Dashboard Dyslexia</h1>
<p><a href="dashboard-dyslexia/">Dashboard Dyslexia</a> is a WIP piece of art by Pandelune.</p>
<a href="dashboard-dyslexia/">
  <img
    src="../dashboard-dyslexia/img/gen/0x78c9ff1bd5bfcdec9ca0cd81fc8c16422cc6b78a9bececeaa3bc14bb57144294.png"
    alt="Dashboard Dyslexia by Pandelune"
  />
</a>
